import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Aswad Amruttulya</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Header />
      <main style={{
        minHeight: '60vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <h1 style={{ fontSize: '4rem', color: '#8B6F47', marginBottom: '1rem' }}>404</h1>
        <p style={{ fontSize: '1.25rem', color: '#666', marginBottom: '2rem' }}>
          {t('page_not_found', 'The page you are looking for does not exist.')}
        </p>
        <Link
          to="/"
          style={{
            padding: '0.75rem 2rem',
            backgroundColor: '#8B6F47',
            color: 'white',
            borderRadius: '8px',
            textDecoration: 'none',
            fontSize: '1rem'
          }}
        >
          {t('go_home', 'Go Back Home')}
        </Link>
      </main>
      <Footer />
    </>
  );
};

export default NotFound;
